import { frontendURL } from 'dashboard/helper/URLHelper';
import ControleAcessoIndex from './Index.vue';

export const routes = [
  {
    // Controle de Acesso por usuario (esconde menus/funcoes). Somente super admin id 1
    // (guard no backend + item de menu so para o id 1).
    path: frontendURL('accounts/:accountId/controle-de-acesso'),
    name: 'controle_acesso',
    component: ControleAcessoIndex,
    meta: {
      permissions: ['administrator'],
    },
  },
];

export default { routes };
